// Чистые функции «Сегодня»: проценты, подписи.

import type { Today } from './api'

/** От стольких шагов за день в «Шагах» загорается 万 («десять тысяч»). */
export const WAN_STEPS = 10_000

/** Доля шагов от цели, 0..100; нет цели — null. */
export function stepsPercent(steps: number, goal: number | null): number | null {
  if (!goal || goal <= 0) return null
  return Math.max(0, Math.min(100, Math.round((steps / goal) * 100)))
}

export const WELLBEING_LABELS: Record<number, string> = {
  1: 'Плохо',
  2: 'Так себе',
  3: 'Нормально',
  4: 'Хорошо',
  5: 'Отлично',
}

export function readinessHint(value: number | null): string | null {
  if (value === null) return null
  if (value >= 75) return 'Можно нагружаться'
  if (value >= 50) return 'Умеренная готовность'
  return 'Лучше полегче'
}

export type ChecklistState = { total: number; done: number; visible: boolean }

export function checklistState(o: Today['onboarding']): ChecklistState {
  return { total: o.items.length, done: o.items.filter((i) => i.done).length, visible: o.visible }
}
